/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimesheetSettings } from './TimesheetSettings';
import {
    TimesheetSettingsFromJSON,
    TimesheetSettingsFromJSONTyped,
    TimesheetSettingsToJSON,
    TimesheetSettingsToJSONTyped,
} from './TimesheetSettings';

/**
 * 
 * @export
 * @interface UpdateTimesheetSettingsResponse
 */
export interface UpdateTimesheetSettingsResponse {
    /**
     * 
     * @type {TimesheetSettings}
     * @memberof UpdateTimesheetSettingsResponse
     */
    data: TimesheetSettings;
}

/**
 * Check if a given object implements the UpdateTimesheetSettingsResponse interface.
 */
export function instanceOfUpdateTimesheetSettingsResponse(value: object): value is UpdateTimesheetSettingsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateTimesheetSettingsResponseFromJSON(json: any): UpdateTimesheetSettingsResponse {
    return UpdateTimesheetSettingsResponseFromJSONTyped(json, false);
}

export function UpdateTimesheetSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTimesheetSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TimesheetSettingsFromJSON(json['data']),
    };
}

  export function UpdateTimesheetSettingsResponseToJSON(json: any): UpdateTimesheetSettingsResponse {
      return UpdateTimesheetSettingsResponseToJSONTyped(json, false);
  }

  export function UpdateTimesheetSettingsResponseToJSONTyped(value?: UpdateTimesheetSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TimesheetSettingsToJSON(value['data']),
    };
}

